module.exports = __webpack_public_path__ + "img/pocket_side_seam.c11e117d.png";